import React from "react";
import axios from 'axios';

// Updated emailApi.js for 2026 BFF Pattern
export function useEmailApi() {
  /**
   * We use useMemo to ensure the axios instance is stable across renders.
   * In the BFF pattern, we no longer depend on a 'token' variable.
   */
  return React.useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_EMAIL_API_BASE_URL ,
      
      // CRITICAL: This allows the browser to automatically send the Session Cookie
      withCredentials: true, 
      
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', 
      }
    });

    /**
     * Optional: Global Response Interceptor
     * If any API call returns 401, the session is dead.
     * We trigger a redirect to the Gateway's login initiation path.
     */
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          console.warn("Session expired. Redirecting to Gateway login...");
          //window.location.href = `${process.env.REACT_APP_NOTIFICATION_SERVICE_APIGW_ENDPOINT}/oauth2/authorization/gateway-client`;
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }, []); // Empty dependency array because the cookie-based instance is static
}
